import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2, Eye } from 'lucide-react';
import PreviewPanel from '../components/rfp/PreviewPanel';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/** Public read-only preview: the documents exactly as the in-app preview shows them, for a colleague or the client sponsor. */
export default function RfpPreviewSharePage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    axios.get(`${API_URL}/api/rfp/response/preview/${token}`).then((r) => setData(r.data))
      .catch((err) => setError(err?.response?.data?.detail || 'This preview link is invalid or has been revoked'));
  }, [token]);
  if (error) return <div className="min-h-screen bg-slate-50 flex items-center justify-center p-6"><p className="text-sm text-slate-500" data-testid="rfp-preview-share-error">{error}</p></div>;
  if (!data) return <div className="min-h-screen bg-slate-50 flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#4ABFCF]" /></div>;
  return (
    <div className="min-h-screen bg-slate-50" data-testid="rfp-preview-share-page">
      <header className="bg-[#0F2040] text-white px-6 py-4">
        <div className="max-w-7xl mx-auto">
          <p className="text-[10px] uppercase tracking-widest text-[#4ABFCF]">Seertech Blueprint · RFP Response — read-only preview</p>
          <h1 className="text-xl font-bold flex items-center gap-2 mt-1"><Eye className="w-5 h-5 text-[#4ABFCF]" />{data.name}</h1>
          <p className="text-xs text-slate-300">{[data.client_name, data.shared_by ? `shared by ${data.shared_by}` : null].filter(Boolean).join(' · ')}</p>
        </div>
      </header>
      <main className="max-w-7xl mx-auto p-6 space-y-4">
        <PreviewPanel project={{ ...data, id: token }} readOnly commentToken={token} comments={data.comments || []} onComment={(c) => setData((d) => ({ ...d, comments: [...(d.comments || []), c] }))} />
        {(data.comments || []).length > 0 && <p className="text-[10px] text-slate-400 text-center" data-testid="rfp-preview-share-comment-count">{data.comments.filter((c) => !c.resolved).length} open · {data.comments.filter((c) => c.resolved).length} handled · {data.comments.reduce((n, c) => n + (c.replies || []).length, 0)} replies from the response team</p>}
        <p className="text-[10px] text-slate-400 text-center pb-6">COMMERCIAL IN CONFIDENCE — Seertech Solutions · Read-only preview{data.expires_at ? ` · Link expires ${new Date(data.expires_at).toLocaleDateString()}` : ''}</p>
      </main>
    </div>
  );
}
